import { getGeolocation } from './getGeolocation'

export const getCountry = async (fallback = true) => {
  const country = await getGeolocation()
  if (!country.country_code) {
    return fallback ? 'US' : ''
  }
  return country.country_code === 'CA' ? 'CA' : 'US'
}

export default getCountry
